var _ = require('lodash'),
  environmentalConfig = require('webpack-config-loader!./environmentalConfig'),
  logger = require('../libraries/logger'),
  enabledFeatures = require('./featureFlags'),
  merchantDefaultConfig = require('./merchantDefaultConfig'),
  merchantSessionConfig,
  paymentBrandDefaultConfig = require('./paymentBrandDefaultConfig'),
  paymentSessionConfig = {},
  RSVP = require('rsvp'),
  systemDefaultConfig = require('./systemDefaultConfig'),
  systemConfig = {};

// Merge static configs with environmental configs set by webpack
_.merge(systemConfig, systemDefaultConfig, environmentalConfig);

var privateMethods = {
  mergePaymentConfig: function (paymentBrand) {
    var merchantSessionConfig = publicMethods.getMerchantConfig(),
      paymentDefaultConfigs = paymentBrandDefaultConfig[paymentBrand] || {},
      merchantGeneralConfig = merchantSessionConfig.payment || {},
      paymentBrandConfig = merchantSessionConfig[paymentBrand] || {},
      mergedConfiguration = {};

    _.merge(mergedConfiguration, paymentDefaultConfigs, merchantGeneralConfig, paymentBrandConfig);
    paymentSessionConfig[paymentBrand] = mergedConfiguration;

    return paymentSessionConfig[paymentBrand];
  }
};

var publicMethods = {  
  /**
   * Merges all Cardinal.configure(namespace, configurationObject) calls into a single configuration object
   * @param {Array} configQueue - An array of all Cardinal.configure calls without the general configuration
   * @returns {Object} merged configuration object or an empty object
   */
  consolidateMerchantConfigOverrides: function (configQueue) {
    var resultConfig = {};

    _.each(configQueue, function (config) {
      var configKeyOrObject = config.arguments[0];
      var configObject = config.arguments[1];

      resultConfig[configKeyOrObject] = configObject;
    });

    return resultConfig;
  },
  /**
   * Parses out the feature flags when given an Init response
   * @param {Object} initResponse The Payload claim of an Init response 
   */
  parseEnabledFeatures: function(initResponse){
    if(initResponse != undefined && typeof initResponse === 'object'){ // eslint-disable-line eqeqeq
      if('FeatureFlags' in initResponse && typeof initResponse.FeatureFlags === 'object' ){
        enabledFeatures = _.merge({}, enabledFeatures, initResponse.FeatureFlags);
      }
    }
  },
  /**
   * Filter out the general configuration from all 'Cardinal.configure' on the page. Removes the general configuration object from the queue
   * @param {Array} configQueue - An array of configuration calls
   * @returns {Object} general configuration or an empty object
   */
  filterMerchantGeneralConfig: function (configQueue) {
    var filteredGeneralConfig = _.remove(configQueue, function (configKey) {
      return !_.isString(configKey.arguments[0]);
    });

    return filteredGeneralConfig.length > 0 ? filteredGeneralConfig[0].arguments[0] : {};
  },
  /**
   * Getter for the feature flags settings. If the Init has already run this value will be the merged value with the default settings. If init has 
   * not run, or failed this value will be the default settings.
   * @returns {FeatureFlags}
   */
  getFeatureFlags: function(){
    return enabledFeatures;
  },
  /**
   * Gets the current merchant configuration after being merged with defaults
   * @returns {object} merged merchantConfiguration
   */
  getMerchantConfig: function () {
    return merchantSessionConfig;
  },
  /**
   * Gets the 'smart default' merchant configuration object
   * @returns {object} configuration object
   */
  getMerchantDefaultConfig: function () {
    return merchantDefaultConfig;
  },
  /**
   * Merges the merchant configurations for a particular payment brand with the payment brand defaults
   * @param {string} paymentBrand - The payment brand key used within the configuration to merge and return
   * @returns {object}
   */
  getPaymentConfig: function (paymentBrand) {
    if (!paymentBrand) {
      return;
    }

    if (paymentSessionConfig[paymentBrand]) {
      return paymentSessionConfig[paymentBrand];
    } else {
      return privateMethods.mergePaymentConfig(paymentBrand);
    }
  },
  /**
   * Returns the default payment brand configurations for a partitular payment brand.
   * @param {string} paymentBrand - The payment brand key used within the configuration to return
   * @returns {object}
   */
  getPaymentBrandDefaultConfig: function (paymentBrand) {
    if (paymentBrand !== undefined) {
      return paymentBrandDefaultConfig[paymentBrand];
    } else {
      return paymentBrandDefaultConfig;
    }
  },
  /**
   * Get the static system configurations. These configuration are internal configurations that drive how songbird works and are not merchant overrideable.
   * @returns {SystemConfigurations} The system level config object
   */
  getSystemConfig: function () {
    /** @type {SystemConfigurations} */
    return systemConfig;
  },
  /**
   * Merges all the Cardinal.configure calls and the merchant default settings into a single unified configuration object. Once the configurations are merged, logging is setup.
   * @param {Array} configQueue - Array of all Cardinal.configure calls
   * @returns {PromiseLike}
   */
  mergeMerchantConfigs: function (configQueue) {
    return new RSVP.Promise(function (resolve, reject) {

      try {
        var generalConfig = publicMethods.filterMerchantGeneralConfig(configQueue),
          overrideConfig = publicMethods.consolidateMerchantConfigOverrides(configQueue),
          resultConfig = {};

        merchantSessionConfig = _.merge(resultConfig, merchantDefaultConfig, generalConfig, overrideConfig);
        logger.initializeLogger(publicMethods.getSystemConfig(), publicMethods.getMerchantConfig().logging, publicMethods.getSystemConfig().logging.level);

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },  
  /**
   * Merges the configurations for a specific payment brand including the buttons configurations. The merged value is stored in a local cache.
   * @param {String} paymentBrand - The payment brand configuration key to merge
   * @returns {Object} merged configuration
   */
  mergePaymentButtonConfigs: function (paymentBrand) {
    var paymentConfig = publicMethods.getPaymentConfig(paymentBrand),
      mergedConfiguration = {};

    if (!paymentBrand) {
      return;
    }

    _.merge(mergedConfiguration, {
      button: systemConfig.button
    }, paymentConfig);

    paymentSessionConfig[paymentBrand] = mergedConfiguration;

    return mergedConfiguration;
  },
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./config/configManager.js
// module id = 24
// module chunks = 0 5 20